export default __webpack_public_path__ + "static/contact-us-7c8079f8cd34ef47bd7636c43dd6aff2.svg";